export const dataCarColors = [
  {
    color: "#34568B",
  },
  {
    color: "#FF6F61",
  },
  {
    color: "#6B5B95",
  },
  {
    color: "#88B04B",
  },
  {
    color: "#B565A7",
  },
  {
    color: "#009B77",
  },
  {
    color: "#EFC050",
  },
  {
    color: "#9B2335",
  },
  {
    color: "#DFCFBE",
  },
];

export const dataLightColors = [
  {
    color: "#57facf",
  },
  { color: "#84b4de" },
  {
    color: "#fefe62",
  },
  {
    color: "#e558ff",
  },
  {
    color: "#fefed8",
  },
];

export const dataWindowColor = [
  {
    color: "#000000",
  },
  {
    color: "#2B0DC0",
  },
  {
    color: "#363539",
  },
  {
    color: "#164525",
  },
  {
    color: "#18A669",
  },
  {
    color: "#5E4F0E",
  },
];
